// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__FCQyW","title":"AfterFrontImage_title__2oArB"};